export const samplePolls = [
  {
    id: 'poll-2026-pm-pick',
    status: 'ongoing',
    question: '你认为下一届首相人选会是？',
    options: [
      { id: 'anwar', label: '安华', votes: 1284 },
      { id: 'muhyiddin', label: '慕尤丁', votes: 942 },
      { id: 'zahid', label: '阿末扎希', votes: 318 },
      { id: 'others', label: '其他', votes: 261 },
    ],
  },
  {
    id: 'poll-2026-state-watch',
    status: 'ongoing',
    question: '你最关注哪一州的选情？',
    options: [
      { id: 'selangor', label: '雪兰莪', votes: 612 },
      { id: 'johor', label: '柔佛', votes: 488 },
      { id: 'penang', label: '槟城', votes: 401 },
      { id: 'sabah', label: '沙巴', votes: 357 },
    ],
  },
  {
    id: 'poll-2024-economy',
    status: 'closed',
    question: '2024 年最重要的选举议题是？',
    closedAt: '2024-12-31',
    options: [
      { id: 'cost', label: '生活成本', votes: 4821 },
      { id: 'jobs', label: '就业机会', votes: 2104 },
      { id: 'corruption', label: '反贪腐', votes: 1893 },
      { id: 'race', label: '种族课题', votes: 612 },
    ],
  },
  {
    id: 'poll-2024-turnout',
    status: 'closed',
    question: '你在 2022 年大选有出来投票吗？',
    closedAt: '2024-08-15',
    options: [
      { id: 'yes', label: '有', votes: 7421 },
      { id: 'no', label: '没有', votes: 1283 },
      { id: 'overseas', label: '海外选民', votes: 412 },
    ],
  },
  {
    id: 'poll-2024-coalition',
    status: 'closed',
    question: '哪个联盟最有希望执政至下一届？',
    closedAt: '2024-05-20',
    options: [
      { id: 'ph', label: '希盟', votes: 3421 },
      { id: 'pn', label: '国盟', votes: 2987 },
      { id: 'bn', label: '国阵', votes: 1102 },
      { id: 'grs', label: '砂盟/沙盟', votes: 892 },
    ],
  },
];
